// extracted by extract-css-chunks-webpack-plugin
module.exports = {"closeButton":"closeButton_DDX3z"};